let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("67L3F")).then(() => parcelRequire('cGDyd'));